<template>
  <div class="row">
    <div class="col-12">
      <card title="Leilões em andamento" subTitle="Primeira página">
        <div slot="raw-content" class="table-responsive">
          <p v-if="loadingCurrent">Carregando...</p>
          <p v-if="errorCurrent" class="text-danger">{{ errorCurrent }}</p>
          <paper-table
            v-else
            :data="tableCurrent.data"
            :columns="tableCurrent.columns"
          >
          </paper-table>
          <p v-if="!loadingCurrent && !errorCurrent && metaCurrent" class="mt-2 text-muted">
            Página {{ metaCurrent.page }} de {{ metaCurrent.totalPages }} ({{ metaCurrent.total }} no total)
          </p>
        </div>
      </card>
    </div>

    <div class="col-12">
      <card class="card-plain">
        <div class="table-full-width table-responsive">
          <paper-table
            type="hover"
            title="Leilões finalizados"
            sub-title="Primeira página"
            :data="tableHistory.data"
            :columns="tableHistory.columns"
          >
          </paper-table>
          <p v-if="loadingHistory">Carregando...</p>
          <p v-if="errorHistory" class="text-danger">{{ errorHistory }}</p>
          <p v-if="!loadingHistory && !errorHistory && metaHistory" class="mt-2 text-muted">
            Página {{ metaHistory.page }} de {{ metaHistory.totalPages }} ({{ metaHistory.total }} no total)
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { PaperTable } from "@/components";
import { getAuctionsCurrent, getAuctionsHistory } from "@/api.js";

const COLUMNS = ["Personagem", "Level", "Classe", "Mundo", "Lance", "Fim"];

function mapItem(a) {
  const c = a.character || {};
  return {
    personagem: c.name || "—",
    level: c.level != null ? c.level : "—",
    classe: c.vocation || "—",
    mundo: c.world || "—",
    lance: a.bidValue != null ? a.bidValue.toLocaleString("pt-BR") : "—",
    fim: a.auctionEnd || "—",
  };
}

export default {
  components: {
    PaperTable,
  },
  data() {
    return {
      loadingCurrent: true,
      errorCurrent: null,
      loadingHistory: true,
      errorHistory: null,
      metaCurrent: null,
      metaHistory: null,
      tableCurrent: {
        columns: [...COLUMNS],
        data: [],
      },
      tableHistory: {
        columns: [...COLUMNS],
        data: [],
      },
    };
  },
  mounted() {
    this.loadCurrent();
    this.loadHistory();
  },
  methods: {
    async loadCurrent() {
      this.loadingCurrent = true;
      this.errorCurrent = null;
      try {
        const res = await getAuctionsCurrent({ page: 1, size: 25 });
        this.tableCurrent.data = (res.items || []).map(mapItem);
        this.metaCurrent = {
          page: res.page,
          totalPages: res.totalPages,
          total: res.total,
        };
      } catch (err) {
        this.errorCurrent = err.message;
      } finally {
        this.loadingCurrent = false;
      }
    },
    async loadHistory() {
      this.loadingHistory = true;
      this.errorHistory = null;
      try {
        const res = await getAuctionsHistory({ page: 1, size: 25 });
        this.tableHistory.data = (res.items || []).map(mapItem);
        this.metaHistory = {
          page: res.page,
          totalPages: res.totalPages,
          total: res.total,
        };
      } catch (err) {
        this.errorHistory = err.message;
      } finally {
        this.loadingHistory = false;
      }
    },
  },
};
</script>
<style></style>
